import { Component, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { PaginationComponent } from 'src/app/components/elements/pagination/pagination.component';
import { PurchaseOrderReceivedService } from 'src/app/services/purchase-order-received.service';
import { PurchasesAssociationService } from 'src/app/services/purchases-association.service';
import { forkJoin, Observable } from 'rxjs';
import { ProductService } from 'src/app/services/product.service';
import { HttpErrorResponse } from '@angular/common/http';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { ScaleService } from 'src/app/services/scale.service';

export interface ProviderData {
  id: number;
  name: string;
  nit: string;
}

export interface PurchaseOrder {
  id: number;
  number: number;
  creationDate: number;
  deliveryDate: number;
  provider: number;
  description: string;
  enteredIntoInventory: boolean;
  providerData: ProviderData;
}

export interface PurchaseOrderDetail {
  id: number;
  purchaseOrder: number;
  product: number;
  warehouse: number;
  quantity: number;   // solicitado
  toReceive: number;  // solicitado (esperado)
  cost: number;
  quantityReceived: number;
  statusType: number;
  statusName: string;
  productData: {
    id: number;
    code: string;
    name: string;
  };
  warehouseData: {
    id: number;
    code: string;
    name: string;
  }
}

interface ScaleItem {
  name: string;
  id: any;
}

// VM para UI
export type ReceiveType = 'ok' | 'miss' | null;
export interface ReceiveRowVm extends PurchaseOrderDetail {
  type: ReceiveType;
  userQuantity: number | null;
  comment?: string;

  showExtra?: boolean;                // para mostrar/ocultar la subtabla
  scaleDetails?: ScaleDetailVm[];
}

export interface ScaleDetailVm {
  weight: number | null;
  unit: string;
  typeId: number;   // 1 = Bruto, 2 = Tara, 3 = Neto
  date: string;
  time: string;
}

// REQUEST exacto del backend
export interface PurchaseOrderReceivedDetailRequest {
  product: number;
  toReceive: number; // cantidad RECIBIDA realmente
}

export interface PurchaseOrderReceivedRequest {
  purchaseOrder: number;
  pilot: string;
  pilotLicense: string;
  plateCar: string;
  platePlatform: string;
  container: string;
  details: PurchaseOrderReceivedDetailRequest[];
}

@Component({
  selector: 'app-order-recieved-unified',
  templateUrl: './order-recieved-unified.component.html',
  styleUrls: ['./order-recieved-unified.component.scss']
})
export class OrderRecievedUnifiedComponent {
  // Fuente de datos
  allOrdersOriginal: PurchaseOrder[] = []; // sin filtrar
  // La lista que muestras (se alimenta de pagination.filter)
  allOrders: PurchaseOrder[] = [];
  selectedOrder: PurchaseOrder | null = null;
  detailsVm: ReceiveRowVm[] = [];

  // Form de transporte/piloto
  pilot = '';
  pilotLicense = '';
  plateCar = '';
  platePlatform = '';
  container = '';
  transactionDescription = '';
  tollManufacturing = false;

  // Estados UI
  loadingOrders = false;
  loadingDetails = false;
  saving = false;

  orderNumberQuery = '';

  pagination = {
    total: [] as PurchaseOrder[],   // dataset *filtrado* actual
    filter: [] as PurchaseOrder[],  // página actual
    pageSize: 10,
    pageIndex: 0,
    startElement: 0,
    lastElement: 0
  };

  allDetails: { [key: number]: PurchaseOrderDetail[] } = {};
  showAssociated = false;

  productQuery = '';
  filteredDetails: ReceiveRowVm[] = [];

  btnDetails = [
    { id: 1, name: 'Bruto' },
    { id: 2, name: 'Tara' },
    { id: 3, name: 'Neto' }
  ];

  @ViewChild(PaginationComponent) paginator!: PaginationComponent;

  editDetailWarehouse: number = null;
  showModalEditWarehouse: boolean = false;
  loadingEditingWarehouse: boolean = false;
  warehouses: WarehouseResponse[] = [];
  filterWarehouse: WarehouseResponse[] = [];
  inputs = {
    warehouse: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null,
        code: null,
        name: null
      }
    }
  }

  loadingScales = false;
  scales: ScaleItem[] = [{ name: 'IND570', id: 'scale1' }, { name: 'IND780', id: 'scale2' }]
  selectedWeightIndex: number | null = null;
  selectedRowIndex: number | null = null;

  constructor(
    private purchaseOrderService: PurchaseOrderService,
    private purchasesAssociationService: PurchasesAssociationService,
    private toast: ToastrService,
    private purchaseOrderReceivedService: PurchaseOrderReceivedService,
    private productService: ProductService,
    private warehouseService: WarehouseService,
    private scaleService: ScaleService
  ) { }

  ngOnInit(): void {
    if (this.showAssociated) {
      this.loadOrders();
    } else {
      this.loadOrdersNotAssociated();
    }
    this.getWarehouses('');
  }

  reloadPage() {
    this.selectedOrder = null;
    this.resetTransportForm();
    if (this.showAssociated) {
      this.loadOrders();
    } else {
      this.loadOrdersNotAssociated();
    }
  }

  loadOrders(): void {
    this.loadingOrders = true;
    this.purchasesAssociationService.getRelatedOrdersByType("TRANSIT").subscribe({
      next: (resp: ResponseObject) => {
        this.allOrdersOriginal = resp?.data ?? [];
        this.loadAllDetails();
        this.loadingOrders = false;
      },
      error: () => {
        this.toast.error('Error al obtener las órdenes');
        this.loadingOrders = false;
      }
    });
  }

  loadOrdersNotAssociated(): void {
    this.loadingOrders = true;
    this.purchasesAssociationService.getRelatedOrdersByNoRelated("").subscribe({
      next: (resp: ResponseObject) => {
        this.allOrdersOriginal = resp?.data ?? [];
        this.allOrdersOriginal = this.allOrdersOriginal.sort((a, b) => b.number - a.number);
        this.loadAllDetails();
        this.loadingOrders = false;
      },
      error: () => {
        this.toast.error('Error al obtener las órdenes');
        this.loadingOrders = false;
      }
    });
  }

  selectOrder(order: PurchaseOrder): void {
    if (this.selectedOrder?.id === order.id) return;
    console.log('Seleccionada orden', order);

    this.selectedOrder = order;
    this.detailsVm = [];
    this.resetTransportForm();
    this.loadDetails(order.id);
  }

  resetTransportForm(): void {
    this.pilot = '';
    this.pilotLicense = '';
    this.plateCar = '';
    this.platePlatform = '';
    this.container = '';
    this.transactionDescription = '';
  }

  loadDetails(orderId: number): void {
    this.loadingDetails = true;
    this.purchaseOrderService.getOrder(orderId).subscribe({
      next: (resp: ResponseObject) => {
        const details: PurchaseOrderDetail[] = resp?.data ?? [];
        this.detailsVm = details.map(d => ({
          ...d,
          type: null,
          userQuantity: null,
          comment: ''
        }));

        // Inicializa el filtro con lo que venga del filtro de la izquierda
        this.productQuery = this.orderNumberQuery;
        this.applyProductFilter();

        this.loadingDetails = false;
      },
      error: () => {
        this.toast.error('Error al obtener el detalle de la orden');
        this.loadingDetails = false;
      }
    });
  }


  applyProductFilter(): void {
    if (!this.productQuery) {
      this.filteredDetails = this.detailsVm;
      return;
    }
    const q = this.productQuery.toLowerCase();
    this.filteredDetails = this.detailsVm.filter(d =>
      d.productData?.name?.toLowerCase().includes(q) ||
      d.productData?.code?.toLowerCase().includes(q)
    );
    this.filteredDetails = this.filteredDetails.map(r => ({
      ...r,
      showExtra: false,
      scaleData: {
        weight: null,
        unit: '',
        typeId: null,
        date: '',
        time: ''
      }
    }));
    console.log(this.filteredDetails);
  }


  // Acciones por fila
  markOk(row: ReceiveRowVm): void {
    row.type = 'ok';
    row.userQuantity = (row.quantity - row.toReceive);
  }

  markMiss(row: ReceiveRowVm): void {
    row.type = 'miss';
    row.userQuantity = (row.quantity - row.toReceive);
  }

  // Metricas y helpers
  get decidedCount(): number {
    return this.detailsVm.filter(r => r.type !== null).length;
  }
  get missCount(): number {
    return this.detailsVm.filter(r => r.type === 'miss').length;
  }
  get okCount(): number {
    return this.detailsVm.filter(r => r.type === 'ok').length;
  }
  difference(row: ReceiveRowVm): number {
    const uq = typeof row.userQuantity === 'number' ? row.userQuantity : 0;
    if (uq > (row.quantity - row.toReceive)) return uq - (row.quantity - row.toReceive);
    return (row.quantity - row.toReceive) - uq;
  }

  // Validaciones
  private isNonEmpty(s: string): boolean {
    return !!s && s.trim().length > 0;
  }

  transportFormValid(): boolean {
    // Ajusta si alguno no es obligatorio en tu flujo
    return this.isNonEmpty(this.transactionDescription);
  }

  rowValid(row: ReceiveRowVm): boolean {
    if (!row.type) return false;
    if (row.type === 'ok') {
      return row.userQuantity === (row.quantity - row.toReceive);
    }
    const uq = row.userQuantity ?? 0;
    return uq >= 0 && uq <= (row.quantity - row.toReceive);
  }

  allRowsValid(): boolean {
    let valid = this.filteredDetails.length > 0 && this.filteredDetails.every(r => this.rowValid(r));
    return valid;
  }

  markAllOk(): void {
    this.filteredDetails.forEach(r => this.markOk(r));
  }

  saveReceived(): void {
    if (!this.selectedOrder) {
      this.toast.warning('Selecciona una orden.');
      return;
    }
    if (!this.transportFormValid()) {
      this.toast.warning('Completa los datos del piloto, placas y contenedor.');
      return;
    }
    if (!this.allRowsValid()) {
      this.toast.warning('Revisa las líneas con errores antes de guardar.');
      return;
    }

    const purchaseOrderReceivedRequest = {
      purchaseOrder: this.selectedOrder.id,
      pilot: this.pilot.trim(),
      pilotLicense: this.pilotLicense.trim(),
      plateCar: this.plateCar.trim(),
      platePlatform: this.platePlatform.trim(),
      container: this.container.trim(),
      tollManufacturing: this.tollManufacturing,
      details: this.detailsVm.filter(rr => rr.toReceive == null || rr.toReceive == 0).map(r => ({
        product: r.product,
        toReceive: Number((r.userQuantity ?? 0) + (r.toReceive ?? 0))
      }))
    };

    const createScaleNoteRequests = this.detailsVm
      .filter(r => r.showExtra && r.scaleDetails)
      .map(r => ({
        equipmentId: this.plateCar + "-" + this.platePlatform,
        vendorId: this.selectedOrder?.providerData?.id ?? null,
        pilot: this.pilot.trim(),
        productId: r.product,
        details: r.scaleDetails.map((s: any) => {
          const combinedDateTime = new Date(`${s.date}T${s.time}`);

          const datePlus6 = new Date(combinedDateTime);
          datePlus6.setHours(datePlus6.getHours() + 6);

          const timeMinus6 = new Date(combinedDateTime);
          timeMinus6.setHours(timeMinus6.getHours() - 6);

          return {
            weight: s.weight,
            typeId: s.typeId,
            date: datePlus6,
            time: timeMinus6.getTime(),
          };
        })
      }));


    console.log("this.detailsVm", this.detailsVm);

    const descriptionEntryNote = this.transactionDescription;

    const payload = {
      purchaseOrderReceivedRequest,
      createScaleNoteRequests,
      descriptionEntryNote
    };

    console.log('Payload final:', payload);

    this.saving = true;
    this.purchaseOrderReceivedService.createUnifiedEntryScale(payload).subscribe({
      next: () => {
        this.toast.success('Recepción y báscula creadas correctamente');
        this.saving = false;
        this.reloadPage();
      },
      error: (err) => {
        this.toast.error(err?.error?.message || 'Error al crear recepción');
        this.saving = false;
      }
    });
  }


  epochToDate(epochMs: number | null | undefined): string {
    if (!epochMs) return '-';
    return new Date(epochMs).toLocaleDateString();
  }

  trackByOrder = (_: number, o: PurchaseOrder) => o.id;
  trackByDetail = (_: number, d: ReceiveRowVm) => d.id;

  get totalMissingUnits(): number {
    return this.detailsVm.reduce((acc, r) => acc + Math.max(0, (r.quantity - r.toReceive) - (r.userQuantity || 0)), 0);
  }

  loadAllDetails() {
    // Creamos un arreglo de observables
    const requests = this.allOrdersOriginal.map((order) =>
      this.purchaseOrderService.getOrder(order.id)
    );

    // Ejecutamos todas en paralelo y esperamos a que terminen
    forkJoin(requests).subscribe({
      next: (responses) => {
        // responses es un array con las respuestas en el mismo orden
        responses.forEach((resp: ResponseObject, index: number) => {
          const orderId = this.allOrdersOriginal[index].id;
          const details: PurchaseOrderDetail[] = resp?.data ?? [];
          this.allDetails[orderId] = details;
        });

        this.applyFilterAndReset();
      },
      error: () => {
        this.toast.error('Error al obtener el detalle de las órdenes');
      }
    });
  }

  applyFilterAndReset(): void {
    const q = (this.orderNumberQuery || '').trim();
    let filtered = this.allOrdersOriginal;

    if (q) {
      // Coincidencia contiene: convierte a string por si mandas "5" y hay 15, 25, etc.
      filtered = this.allOrdersOriginal.filter(o =>
        o?.number?.toString().includes(q) || this.filterForDetail(q, o.id)
      );
    }

    this.pagination.total = filtered;
    // Reinicia el componente de paginación para recalcular filter
    // Si el ViewChild aún no está, haz un fallback manual:
    if (this.paginator) {
      this.paginator.reset();
    } else {
      this.pagination.pageIndex = 0;
      this.pagination.startElement = 0;
      const temporalLast = Math.min(this.pagination.pageSize, this.pagination.total.length);
      this.pagination.lastElement = temporalLast;
      this.pagination.filter = this.pagination.total.slice(0, temporalLast);
    }

    // Mantén una referencia conveniente si la necesitas en la plantilla
    this.allOrders = this.pagination.filter;
  }

  filterForDetail(value: string, orderId: number) {
    const listDetails = this.allDetails[orderId] ?? [];
    value = value.toLowerCase();

    return listDetails.some(detail =>
      detail.productData.name.toLowerCase().includes(value)
    );
  }

  /** Recibe eventos del paginador (no necesitas usar el $event para cliente-side) */
  onPageChanged(_: any): void {
    // El componente de paginación ya actualiza pagination.filter.
    this.allOrders = this.pagination.filter;
  }

  /** Limpia el filtro rápidamente */
  clearOrderFilter(): void {
    this.orderNumberQuery = '';
    this.applyFilterAndReset();
  }

  toggleShowAssociated(show: boolean): void {
    this.showAssociated = show;
    if (this.showAssociated) {
      this.loadOrders();
    } else {
      this.loadOrdersNotAssociated();
    }
  }

  async toggleExtra(row: ReceiveRowVm, idProduct: number): Promise<void> {
    row.showExtra = !row.showExtra;

    if (row.showExtra && !row.scaleDetails) {
      const now = new Date();
      const today = now.toISOString().substring(0, 10);
      const time = now.toTimeString().substring(0, 8);

      // Esperar a obtener la unidad del producto
      const unitsString = await this.getUnitByProductId(idProduct);

      row.scaleDetails = [
        { typeId: 1, weight: 0, unit: unitsString, date: today, time },
        { typeId: 2, weight: 0, unit: unitsString, date: today, time },
        { typeId: 3, weight: 0, unit: unitsString, date: today, time }
      ];
    }
  }

  async getUnitByProductId(productId: number): Promise<string> {
    try {
      const response: ResponseObject = await this.productService
        .getMeasurementsByProductId(productId)
        .toPromise();

      if (response?.data?.unit) {
        return response.data.unit;
      } else {
        return 'Unidades';
      }
    } catch (error) {
      const httpError = error as HttpErrorResponse;
      console.error('Error obteniendo unidad:', httpError.message);
      return 'Unidades';
    }
  }

  timeStringToSeconds(time: string): number {
    const [hours, minutes, seconds = '0'] = time.split(':');
    return (+hours * 3600) + (+minutes * 60) + (+seconds);
  }

  updateScaleAndQuantity(row: ReceiveRowVm): void {
    if (!row.scaleDetails) return;

    const bruto = row.scaleDetails.find(d => d.typeId === 1)?.weight ?? 0;
    const tara = row.scaleDetails.find(d => d.typeId === 2)?.weight ?? 0;
    const netoDetail = row.scaleDetails.find(d => d.typeId === 3);

    const neto = bruto - tara;

    if (netoDetail) {
      netoDetail.weight = neto;
    }

    row.userQuantity = neto;

    const esperado = row.quantity - row.toReceive;

    if (neto < esperado) {
      row.type = 'miss';
    } else {
      row.type = 'ok';
    }
  }

  getWarehouses(searchValue: string) {
    this.warehouseService.getWarehouseByClue(searchValue).subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.filterWarehouse = this.warehouses;

        if (this.filterWarehouse.length == 0) {
          this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
        } else if (this.filterWarehouse.length == 1) {
          this.changeInput(this.inputs.warehouse, this.filterWarehouse[0].name, true, null, 'fa-circle-check', this.filterWarehouse[0]);
        } else {
          this.changeInput(this.inputs.warehouse, searchValue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toast.error("Error al obtener las bodegas", "Error");
      }
    });
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  writeWarehouse(input) {
    const inputValue = input.target.value;

    this.filterWarehouse = this.warehouses.filter((w) =>
      w.name.toLowerCase().includes(inputValue.toLowerCase())
      || w.code.toLowerCase().includes(inputValue.toLowerCase())
    );

    if (this.filterWarehouse.length == 0) {
      this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
    } else if (this.filterWarehouse.length == 1) {
      this.changeInput(this.inputs.warehouse, this.filterWarehouse[0].name, true, null, 'fa-circle-check', this.filterWarehouse[0]);
    } else {
      this.changeInput(this.inputs.warehouse, input.target.value, false, null, 'fa-list', null);
    }
  }

  checkWarehouse(warehouse: WarehouseResponse) {
    this.inputs.warehouse.class = "fa-circle-check";
    this.inputs.warehouse.verified = true;
    this.inputs.warehouse.data = warehouse;
    this.inputs.warehouse.value = warehouse.name;
  }

  closeModalEditWarehouseDetail(event: any) {
    this.editDetailWarehouse = null;
    this.showModalEditWarehouse = false;
  }

  setEditWarehouseDetail(detailId: number): void {
    this.editDetailWarehouse = detailId;
    this.showModalEditWarehouse = true;
  }

  updateWarehouseDetail(): void {
    if (!this.editDetailWarehouse) {
      return;
    }
    if (!this.inputs.warehouse.verified) {
      this.toast.warning("Selecciona una bodega válida", "Validación");
      return;
    }

    this.loadingEditingWarehouse = true;
    this.purchaseOrderService.putEditDetailWarehouse(this.editDetailWarehouse, this.inputs.warehouse.data.id).subscribe({
      next: () => {
        this.toast.success("Bodega actualizada correctamente", "Éxito");
        // Actualiza en la UI localmente
        const detailVm = this.detailsVm.find(d => d.id === this.editDetailWarehouse);
        if (detailVm) {
          detailVm.warehouse = this.inputs.warehouse.data.id;
          detailVm.warehouseData = {
            id: this.inputs.warehouse.data.id,
            code: this.inputs.warehouse.data.code,
            name: this.inputs.warehouse.data.name
          };
        }
        this.loadingEditingWarehouse = false;
        this.closeModalEditWarehouseDetail(undefined);
      },
      error: (error: HttpErrorResponse) => {
        this.toast.error("Error al actualizar la bodega", "Error");
        this.loadingEditingWarehouse = false;
      }
    });
  }

  setWeightSelected(scaleId: any, item: ReceiveRowVm) {
    this.scaleService.getScalesValue(scaleId).subscribe({
      next: (response: any) => {
        console.log(response);
        if (this.selectedRowIndex == null || this.selectedWeightIndex == null) {
          this.toast.info("No tienes seleccionado un input");
          return
        }

        if (item.scaleDetails && item.scaleDetails[this.selectedWeightIndex]) {
          item.scaleDetails[this.selectedWeightIndex].weight = response.weight ?? 0;
        }
      },
      error: (error: any) => {
        console.log(error);
        this.toast.error("Error al obtener valores");
        // if (this.selectedRowIndex == null || this.selectedWeightIndex == null) {
        //   return
        // }

        // if (item.scaleDetails && item.scaleDetails[this.selectedWeightIndex]) {
        //   item.scaleDetails[this.selectedWeightIndex].weight = 2;
        // }
      }
    });
  }
}


